var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo804(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 184.22,
    height: 66.499,
    viewBox: "0 0 184.22 66.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Union_4",
    x: 0,
    y: 0,
    width: 184.22,
    height: 66.499,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AllGood_logo_rgb",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALLGOOD_Logo_RGB_horizontal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5753",
    "data-name": "Group 5753"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Union_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_4-2",
    "data-name": "Union 4",
    d: "M7.1,41.4A24.25,24.25,0,0,1,41.4,7.1,24.25,24.25,0,0,1,7.1,41.4ZM46.065,17.87ZM2.449,17.821h0Zm1.736-4.245Zm47.193,34.7V19.7L54.725,1.865l.206-1.1H66.571L66.8,1.836l2.151,10.228V.759h9.224V14.924H81V.759h9.224V14.924h2.247c-.014-.358-.022-.745-.022-1.172V8.491a13.668,13.668,0,0,1,.457-4.12A5.379,5.379,0,0,1,95.785,1.5a11.614,11.614,0,0,1,5.37-1.109,13.215,13.215,0,0,1,5.3.945,5.939,5.939,0,0,1,3.124,2.606,6.189,6.189,0,0,1,.523,1.619c.005-.034.01-.068.015-.1a4.977,4.977,0,0,1,1.5-2.782A7.478,7.478,0,0,1,114.7.938a14.073,14.073,0,0,1,4.115-.552A14.355,14.355,0,0,1,122.8.9a7.492,7.492,0,0,1,3.131,1.714,5,5,0,0,1,1.536,2.65,5.036,5.036,0,0,1,1.465-2.591A7.489,7.489,0,0,1,132.015.94a14.036,14.036,0,0,1,4.113-.552,14.367,14.367,0,0,1,3.992.518,7.487,7.487,0,0,1,3.131,1.714,5.074,5.074,0,0,1,1.488,2.43V.757h6.228a43.072,43.072,0,0,1,6.628.33,7.526,7.526,0,0,1,2.659.952A1.634,1.634,0,0,1,161.58,1.1h.1l3.226.018h.164a1.018,1.018,0,0,1,1.014.954l.132,2.128a1.014,1.014,0,0,1-1.012,1.079H162.4a24.093,24.093,0,0,1,.141,3.079v6.2a10.818,10.818,0,0,1-.413,3.687,3.808,3.808,0,0,1-1.69,1.934,7.025,7.025,0,0,1-2.42.8c-.269.041-.572.075-.914.1h5.431V48.272Zm74.629-29.014A7.472,7.472,0,0,1,122.927,21c-.1.032-.208.061-.312.09h9.73c-.069-.017-.139-.034-.206-.054a7.531,7.531,0,0,1-3.133-1.715,5.009,5.009,0,0,1-1.534-2.649A5.017,5.017,0,0,1,126.007,19.257Zm-15.711.564v1.265h4.733c-.069-.019-.139-.036-.207-.056a7.509,7.509,0,0,1-3.131-1.714,5.2,5.2,0,0,1-1.4-2.119Zm33.026-.566A7.446,7.446,0,0,1,140.242,21c-.1.032-.208.061-.315.088h4.813v-4.2A5.063,5.063,0,0,1,143.322,19.256Zm-49.136.566h0v1.263h2.963c-.186-.061-.369-.124-.55-.195a7.247,7.247,0,0,1-2.415-1.468Z",
    transform: "translate(9 6)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5758",
    "data-name": "Group 5758",
    transform: "translate(1.524 1.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5754",
    "data-name": "Group 5754",
    transform: "translate(0 0.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M98.66,398.726a22.787,22.787,0,0,0,18.3,0l-9.153-28.166Z",
    transform: "translate(-85.086 -355.794)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M200.893,305.488A22.734,22.734,0,0,0,183.36,283.36l12.015,36.97A22.63,22.63,0,0,0,200.893,305.488Z",
    transform: "translate(-155.443 -283.36)",
    fill: "#374a86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M18.5,305.488a22.622,22.622,0,0,0,5.519,14.842l12.013-36.97A22.734,22.734,0,0,0,18.5,305.488Z",
    transform: "translate(-18.5 -283.36)",
    fill: "#374a86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5757",
    "data-name": "Group 5757",
    transform: "translate(51.208 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1741",
    "data-name": "Rectangle 1741",
    width: 50.03,
    height: 11.107,
    transform: "translate(58.415 20.698)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1742",
    "data-name": "Rectangle 1742",
    width: 56.155,
    height: 11.107,
    transform: "translate(0 20.698)",
    fill: "#374a86"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1743",
    "data-name": "Rectangle 1743",
    width: 50.03,
    height: 11.105,
    transform: "translate(58.415 34.066)",
    fill: "#374a86"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1744",
    "data-name": "Rectangle 1744",
    width: 56.155,
    height: 11.105,
    transform: "translate(0 34.066)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5755",
    "data-name": "Group 5755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M333.639,285.01l3.724,17.709h-6.657l-.349-3.182h-2.33l-.393,3.182H320.9l3.324-17.709ZM330.186,296.4q-.5-3.008-.992-7.437-1,5.085-1.25,7.437Z",
    transform: "translate(-320.9 -284.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M431.174,285.01v14.165h3.963v3.543H424.66V285.01Z",
    transform: "translate(-407.089 -284.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M502.354,285.01v14.165h3.962v3.543H495.84V285.01Z",
    transform: "translate(-466.216 -284.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M578.577,289.71h-6.514V288.1a5.7,5.7,0,0,0-.186-1.9c-.124-.256-.417-.383-.882-.383a.911.911,0,0,0-.82.328,3.847,3.847,0,0,0-.217,1.685v8.5a3.639,3.639,0,0,0,.217,1.57.91.91,0,0,0,.867.378,1.028,1.028,0,0,0,.965-.429,3.639,3.639,0,0,0,.256-1.663v-2.1h-1.316V291.4h7.629v9.5h-4.095l-.6-1.268a4.107,4.107,0,0,1-1.682,1.231,6.373,6.373,0,0,1-2.393.412,8.31,8.31,0,0,1-3.074-.564,5.625,5.625,0,0,1-2.176-1.4,3.723,3.723,0,0,1-.93-1.746,14.883,14.883,0,0,1-.186-2.74v-5.261a12.632,12.632,0,0,1,.386-3.685,4.188,4.188,0,0,1,2.222-2.107,10.232,10.232,0,0,1,4.743-.957,11.828,11.828,0,0,1,4.75.83A4.723,4.723,0,0,1,578,285.624a7.608,7.608,0,0,1,.574,3.321v.765Z",
    transform: "translate(-522.368 -282.82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M681.711,293.561a27.636,27.636,0,0,1-.178,3.778,3.64,3.64,0,0,1-1.114,2.029,6.126,6.126,0,0,1-2.531,1.412,12.61,12.61,0,0,1-3.714.493,12.956,12.956,0,0,1-3.614-.466,6.135,6.135,0,0,1-2.576-1.4,3.626,3.626,0,0,1-1.16-2.024,26.558,26.558,0,0,1-.185-3.827v-3.029a27.445,27.445,0,0,1,.176-3.78,3.635,3.635,0,0,1,1.114-2.029,6.1,6.1,0,0,1,2.53-1.411,12.618,12.618,0,0,1,3.715-.493,12.976,12.976,0,0,1,3.614.464,6.124,6.124,0,0,1,2.574,1.4,3.633,3.633,0,0,1,1.162,2.024,26.274,26.274,0,0,1,.186,3.829v3.029Zm-6.516-5.818a3.97,3.97,0,0,0-.193-1.582.836.836,0,0,0-.8-.344,1.042,1.042,0,0,0-.782.279,2.917,2.917,0,0,0-.269,1.646v8.269a5.851,5.851,0,0,0,.176,1.9c.12.241.4.361.83.361a.832.832,0,0,0,.85-.417,6.273,6.273,0,0,0,.186-1.981v-8.135Z",
    transform: "translate(-608.092 -282.82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M783.951,293.561a27.32,27.32,0,0,1-.178,3.778,3.628,3.628,0,0,1-1.114,2.029,6.118,6.118,0,0,1-2.53,1.412,12.6,12.6,0,0,1-3.712.493,12.964,12.964,0,0,1-3.614-.466,6.151,6.151,0,0,1-2.578-1.4,3.64,3.64,0,0,1-1.162-2.024,26.567,26.567,0,0,1-.185-3.827v-3.029a27.348,27.348,0,0,1,.178-3.78,3.646,3.646,0,0,1,1.114-2.029,6.1,6.1,0,0,1,2.532-1.411,12.614,12.614,0,0,1,3.714-.493,12.958,12.958,0,0,1,3.612.464,6.132,6.132,0,0,1,2.575,1.4,3.631,3.631,0,0,1,1.16,2.024,26.253,26.253,0,0,1,.186,3.829Zm-6.515-5.818a3.971,3.971,0,0,0-.193-1.582.835.835,0,0,0-.8-.344,1.039,1.039,0,0,0-.782.279,2.9,2.9,0,0,0-.269,1.646v8.269a5.853,5.853,0,0,0,.176,1.9q.178.361.83.361a.832.832,0,0,0,.85-.417,6.223,6.223,0,0,0,.186-1.981l0-8.135Z",
    transform: "translate(-693.019 -282.82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M872.23,285.01H877.1a42.476,42.476,0,0,1,6.384.308,5.636,5.636,0,0,1,2.53,1.006,2.958,2.958,0,0,1,1.084,1.558,16.933,16.933,0,0,1,.217,3.375v6.2a10.307,10.307,0,0,1-.318,3.189,2.472,2.472,0,0,1-1.106,1.258,5.66,5.66,0,0,1-1.949.635,25.108,25.108,0,0,1-3.5.179H872.23V285.01Zm6.513,3.029v11.649q1.41,0,1.732-.4a4.257,4.257,0,0,0,.325-2.171v-6.879a6.634,6.634,0,0,0-.109-1.543.805.805,0,0,0-.5-.5A4.4,4.4,0,0,0,878.743,288.039Z",
    transform: "translate(-778.868 -284.639)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M332.26,416.29h2.708a9.058,9.058,0,0,1,1.69.122,2.238,2.238,0,0,1,.891.352,1.151,1.151,0,0,1,.4.557,3.54,3.54,0,0,1,.107,1.014v.637a1.946,1.946,0,0,1-.2,1.021,1.311,1.311,0,0,1-.75.493,4.858,4.858,0,0,1-1.428.171h-.721V423.6h-2.689V416.29h0Zm2.691,1.251V419.4c.076,0,.142,0,.2,0a.78.78,0,0,0,.515-.129.728.728,0,0,0,.144-.535v-.6a.562.562,0,0,0-.168-.488A1.419,1.419,0,0,0,334.951,417.541Z",
    transform: "translate(-330.336 -393.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M373.741,416.29v5.851h1.636V423.6H371.05V416.29Z",
    transform: "translate(-362.558 -393.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M406.365,416.29v4.889a6.033,6.033,0,0,1-.078,1.168,1.4,1.4,0,0,1-.454.689,2.425,2.425,0,0,1-.992.539,5.159,5.159,0,0,1-1.456.183,5.569,5.569,0,0,1-1.636-.218,2.538,2.538,0,0,1-1.06-.564,1.354,1.354,0,0,1-.417-.733,12.813,12.813,0,0,1-.063-1.624V416.29H402.9v5.485a1.6,1.6,0,0,0,.073.613.308.308,0,0,0,.3.132c.171,0,.279-.049.328-.146a1.967,1.967,0,0,0,.073-.694v-5.39Z",
    transform: "translate(-386.78 -393.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M451.011,416.29V423.6h-2.35l0-4.936-.936,4.936h-1.668l-.989-4.823,0,4.823h-2.35V416.29h3.48c.1.44.21.959.32,1.555l.383,1.861.618-3.416Z",
    transform: "translate(-422.083 -393.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M498.11,416.29h2.684a9.9,9.9,0,0,1,1.927.141,1.978,1.978,0,0,1,1.057.567,1.954,1.954,0,0,1,.4,1.375,1.155,1.155,0,0,1-.284.893,2.344,2.344,0,0,1-1.123.388,2.27,2.27,0,0,1,1.267.494,1.479,1.479,0,0,1,.334,1.06v.677a2.007,2.007,0,0,1-.241,1.1,1.244,1.244,0,0,1-.764.488,11.291,11.291,0,0,1-2.149.129H498.11Zm2.689,1.251v1.626c.115,0,.2-.005.267-.005.264,0,.434-.046.5-.137a1.627,1.627,0,0,0,.11-.789.945.945,0,0,0-.09-.481.391.391,0,0,0-.232-.174A3.021,3.021,0,0,0,500.8,417.541Zm0,2.764v2.046a1.533,1.533,0,0,0,.727-.125c.1-.074.157-.259.157-.555v-.682c0-.312-.047-.5-.141-.569A1.721,1.721,0,0,0,500.8,420.3Z",
    transform: "translate(-468.101 -393.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M543.471,416.29V423.6H540.78V416.29Z",
    transform: "translate(-503.546 -393.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M569.056,416.29V423.6H566.7l-1.4-3.324V423.6H563.05V416.29H565.3l1.509,3.294V416.29Z",
    transform: "translate(-522.044 -393.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M610.7,418.235h-2.689v-.664a2.371,2.371,0,0,0-.076-.786c-.051-.105-.173-.157-.364-.157a.369.369,0,0,0-.339.137,1.591,1.591,0,0,0-.09.694v3.51a1.488,1.488,0,0,0,.09.647.381.381,0,0,0,.359.156.431.431,0,0,0,.4-.176,1.518,1.518,0,0,0,.1-.688v-.867h-.544v-1.113h3.15v3.925h-1.69l-.251-.522a1.693,1.693,0,0,1-.694.508,2.615,2.615,0,0,1-.987.169,3.465,3.465,0,0,1-1.27-.232,2.313,2.313,0,0,1-.9-.576,1.534,1.534,0,0,1-.385-.72,6.179,6.179,0,0,1-.078-1.133v-2.173a5.259,5.259,0,0,1,.159-1.522,1.737,1.737,0,0,1,.918-.87,4.238,4.238,0,0,1,1.959-.394,4.918,4.918,0,0,1,1.961.342,1.962,1.962,0,0,1,1.016.815,3.154,3.154,0,0,1,.237,1.372v.317Z",
    transform: "translate(-556.434 -392.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M677.09,416.29h4.486v1.463h-1.8v1.387h1.68v1.39h-1.68v1.609h1.974V423.6H677.09Z",
    transform: "translate(-616.773 -393.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    d: "M711.889,416.29v5.851h1.636V423.6H709.2V416.29Z",
    transform: "translate(-643.446 -393.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    d: "M738.59,416.29h4.488v1.463h-1.8v1.387h1.68v1.39h-1.68v1.609h1.974V423.6H738.59Z",
    transform: "translate(-667.859 -393.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M776.617,418.743h-2.689v-1.27a1.639,1.639,0,0,0-.086-.691c-.059-.091-.185-.137-.381-.137q-.332,0-.421.168a1.835,1.835,0,0,0-.09.723v3.4a1.73,1.73,0,0,0,.09.7c.059.108.193.161.4.161s.332-.052.393-.163a1.93,1.93,0,0,0,.093-.765v-.92h2.689v.285a4.044,4.044,0,0,1-.227,1.61,1.938,1.938,0,0,1-1,.833,4.589,4.589,0,0,1-1.913.357,5.365,5.365,0,0,1-1.949-.3,1.746,1.746,0,0,1-1.016-.838,4.011,4.011,0,0,1-.249-1.609v-2.135a6.644,6.644,0,0,1,.076-1.187,1.461,1.461,0,0,1,.456-.76,2.627,2.627,0,0,1,1.055-.576,5.247,5.247,0,0,1,1.549-.21,5.123,5.123,0,0,1,1.961.324,1.892,1.892,0,0,1,1.016.811,3.552,3.552,0,0,1,.242,1.509l0,.689Z",
    transform: "translate(-694.166 -392.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M816.668,416.29v1.463h-1.6V423.6H812.38v-5.849h-1.59V416.29Z",
    transform: "translate(-727.832 -393.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M849.12,416.29h1.905a20.4,20.4,0,0,1,2.577.105,1.9,1.9,0,0,1,1.1.53,1.875,1.875,0,0,1,.427,1.361,1.616,1.616,0,0,1-.3,1.148,1.913,1.913,0,0,1-1.182.352,2.375,2.375,0,0,1,1.072.376,1.086,1.086,0,0,1,.344.43,4.879,4.879,0,0,1,.068,1.082V423.6h-2.5v-2.428a1.241,1.241,0,0,0-.13-.726c-.088-.095-.317-.141-.686-.141v3.3H849.12Zm2.692,1.251v1.626a1.581,1.581,0,0,0,.633-.088c.122-.059.183-.251.183-.571v-.4a.5.5,0,0,0-.176-.456A1.29,1.29,0,0,0,851.812,417.541Z",
    transform: "translate(-759.672 -393.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M893.441,416.29V423.6H890.75V416.29Z",
    transform: "translate(-794.252 -393.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M918.927,418.743h-2.691v-1.27a1.635,1.635,0,0,0-.087-.691c-.057-.091-.185-.137-.379-.137q-.333,0-.422.168a1.827,1.827,0,0,0-.091.723v3.4a1.691,1.691,0,0,0,.091.7c.059.108.193.161.4.161s.332-.052.393-.163a1.939,1.939,0,0,0,.092-.765v-.92h2.691v.285a4.042,4.042,0,0,1-.227,1.61,1.943,1.943,0,0,1-1,.833,4.59,4.59,0,0,1-1.913.357,5.371,5.371,0,0,1-1.949-.3,1.745,1.745,0,0,1-1.016-.838,3.982,3.982,0,0,1-.249-1.609v-2.135a6.619,6.619,0,0,1,.078-1.187,1.461,1.461,0,0,1,.456-.76,2.624,2.624,0,0,1,1.055-.576,5.245,5.245,0,0,1,1.549-.21,5.115,5.115,0,0,1,1.961.324,1.892,1.892,0,0,1,1.016.811,3.523,3.523,0,0,1,.244,1.509v.689Z",
    transform: "translate(-812.377 -392.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M338.454,495.2v7.314h-2.691v-3.07h-.8v3.07H332.27V495.2h2.689v2.615h.8V495.2Z",
    transform: "translate(-330.345 -459.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M385.98,495.2h4.486v1.465h-1.793v1.385h1.68v1.392h-1.68v1.607h1.975v1.463H385.98Z",
    transform: "translate(-374.959 -459.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M430.571,495.2l1.538,7.314h-2.748l-.146-1.314h-.962l-.161,1.314H425.31l1.372-7.314Zm-1.426,4.7q-.206-1.242-.408-3.072-.414,2.1-.517,3.072Z",
    transform: "translate(-407.629 -459.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    d: "M477.888,495.2v1.465h-1.6v5.849H473.6v-5.849H472.01V495.2Z",
    transform: "translate(-446.421 -459.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M522.309,495.2v7.314H519.62V495.2Z",
    transform: "translate(-485.969 -459.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M558.706,495.2v7.314h-2.359l-1.4-3.324v3.324H552.7V495.2h2.247l1.509,3.294V495.2Z",
    transform: "translate(-513.447 -459.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M610.644,497.137h-2.691v-.662a2.3,2.3,0,0,0-.078-.786c-.051-.105-.173-.158-.364-.158a.378.378,0,0,0-.339.135,1.586,1.586,0,0,0-.091.694v3.509a1.478,1.478,0,0,0,.091.649.374.374,0,0,0,.357.157.426.426,0,0,0,.4-.178,1.516,1.516,0,0,0,.1-.687v-.867h-.544v-1.111h3.151v3.925H608.95l-.249-.525a1.677,1.677,0,0,1-.694.508,2.617,2.617,0,0,1-.989.169,3.435,3.435,0,0,1-1.27-.232,2.291,2.291,0,0,1-.9-.576,1.561,1.561,0,0,1-.386-.72,6.21,6.21,0,0,1-.076-1.133v-2.173a5.136,5.136,0,0,1,.161-1.522,1.725,1.725,0,0,1,.916-.869,4.2,4.2,0,0,1,1.959-.4,4.866,4.866,0,0,1,1.963.344,1.953,1.953,0,0,1,1.016.815,3.152,3.152,0,0,1,.237,1.372v.317Z",
    transform: "translate(-556.384 -458.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M683.447,497.629h-2.691v-1.272a1.684,1.684,0,0,0-.085-.693c-.059-.091-.185-.137-.381-.137-.222,0-.362.054-.422.166a1.841,1.841,0,0,0-.09.723v3.4a1.686,1.686,0,0,0,.09.7c.059.108.193.163.4.163a.416.416,0,0,0,.393-.163,1.951,1.951,0,0,0,.091-.765v-.918h2.691v.285a4.051,4.051,0,0,1-.227,1.61,1.94,1.94,0,0,1-1,.832,4.548,4.548,0,0,1-1.912.357,5.366,5.366,0,0,1-1.949-.3,1.76,1.76,0,0,1-1.016-.838,3.991,3.991,0,0,1-.249-1.61v-2.135a6.6,6.6,0,0,1,.078-1.187,1.449,1.449,0,0,1,.455-.76,2.629,2.629,0,0,1,1.055-.577,5.193,5.193,0,0,1,1.549-.21,5.1,5.1,0,0,1,1.963.325,1.888,1.888,0,0,1,1.016.81,3.556,3.556,0,0,1,.242,1.509v.7Z",
    transform: "translate(-616.773 -458.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M728.825,498.727a11.316,11.316,0,0,1-.073,1.561,1.488,1.488,0,0,1-.46.836,2.506,2.506,0,0,1-1.045.584,5.151,5.151,0,0,1-1.532.2,5.406,5.406,0,0,1-1.494-.191,2.556,2.556,0,0,1-1.065-.576,1.515,1.515,0,0,1-.479-.835,11.056,11.056,0,0,1-.076-1.582v-1.251a11.306,11.306,0,0,1,.073-1.561,1.5,1.5,0,0,1,.46-.838,2.553,2.553,0,0,1,1.045-.584,5.153,5.153,0,0,1,1.534-.2,5.324,5.324,0,0,1,1.492.193,2.541,2.541,0,0,1,1.063.576,1.5,1.5,0,0,1,.479.836,11.009,11.009,0,0,1,.076,1.582l0,1.25Zm-2.689-2.4a1.644,1.644,0,0,0-.08-.652.345.345,0,0,0-.328-.142.427.427,0,0,0-.324.115,1.2,1.2,0,0,0-.112.679v3.415a2.445,2.445,0,0,0,.073.786c.049.1.163.149.342.149a.345.345,0,0,0,.352-.173,2.664,2.664,0,0,0,.076-.818v-3.36Z",
    transform: "translate(-654.576 -458.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M774.055,498.727a11.242,11.242,0,0,1-.075,1.561,1.5,1.5,0,0,1-.459.836,2.536,2.536,0,0,1-1.045.584,5.165,5.165,0,0,1-1.534.2,5.384,5.384,0,0,1-1.492-.191,2.529,2.529,0,0,1-1.063-.576,1.5,1.5,0,0,1-.479-.835,10.731,10.731,0,0,1-.078-1.582v-1.251a11.575,11.575,0,0,1,.073-1.561,1.519,1.519,0,0,1,.461-.838,2.555,2.555,0,0,1,1.045-.584,5.158,5.158,0,0,1,1.532-.2,5.316,5.316,0,0,1,1.492.193,2.533,2.533,0,0,1,1.063.576,1.5,1.5,0,0,1,.479.836,10.691,10.691,0,0,1,.078,1.582v1.25Zm-2.691-2.4a1.61,1.61,0,0,0-.08-.652.346.346,0,0,0-.328-.142.43.43,0,0,0-.324.115,1.2,1.2,0,0,0-.112.679v3.415a2.393,2.393,0,0,0,.073.786c.049.1.164.149.342.149a.345.345,0,0,0,.352-.173,2.527,2.527,0,0,0,.078-.818v-3.36Z",
    transform: "translate(-692.147 -458.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M816.449,495.2v5.849h1.636v1.463H813.76V495.2Z",
    transform: "translate(-730.299 -459.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M848.921,495.2v7.314H846.23V495.2Z",
    transform: "translate(-757.271 -459.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M877.606,495.2v7.314h-2.359l-1.4-3.324v3.324H871.6V495.2h2.249l1.507,3.294V495.2Z",
    transform: "translate(-778.345 -459.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M919.462,497.137h-2.691v-.662a2.313,2.313,0,0,0-.076-.786q-.076-.158-.366-.158a.376.376,0,0,0-.337.135,1.566,1.566,0,0,0-.09.694v3.509a1.508,1.508,0,0,0,.09.649.373.373,0,0,0,.357.157.423.423,0,0,0,.4-.178,1.485,1.485,0,0,0,.107-.687v-.867h-.544v-1.111h3.15v3.925h-1.69l-.247-.525a1.692,1.692,0,0,1-.7.508,2.614,2.614,0,0,1-.987.169,3.429,3.429,0,0,1-1.27-.232,2.3,2.3,0,0,1-.9-.576,1.553,1.553,0,0,1-.384-.72,6.006,6.006,0,0,1-.078-1.133v-2.173a5.2,5.2,0,0,1,.159-1.522,1.743,1.743,0,0,1,.918-.869,4.2,4.2,0,0,1,1.958-.4,4.846,4.846,0,0,1,1.961.344,1.954,1.954,0,0,1,1.018.815,3.157,3.157,0,0,1,.235,1.372v.317Z",
    transform: "translate(-812.909 -458.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5756",
    "data-name": "Group 5756",
    transform: "translate(108.699 0.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M962.868,286.839a.971.971,0,0,0,.493.139c.281,0,.445-.147.445-.364,0-.2-.114-.313-.4-.423-.347-.124-.561-.3-.561-.6a.612.612,0,0,1,.688-.577.96.96,0,0,1,.471.105l-.076.224a.85.85,0,0,0-.406-.1c-.29,0-.4.174-.4.318,0,.2.129.3.423.411.36.139.542.313.542.627,0,.329-.242.613-.745.613a1.085,1.085,0,0,1-.542-.137Z",
    transform: "translate(-962.8 -285.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M974.1,286.412c-.016-.3-.034-.654-.032-.919h-.01c-.075.251-.161.513-.269.809l-.376,1.033H973.2l-.345-1.014c-.1-.3-.186-.574-.247-.826H972.6c-.005.266-.02.621-.042.94l-.058.914h-.264l.147-2.129h.351l.364,1.03c.089.264.161.495.217.716h.01c.052-.217.129-.447.224-.716l.379-1.03h.351l.132,2.129h-.269Z",
    transform: "translate(-970.641 -285.184)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo804);
export default __webpack_public_path__ + "static/media/logo_804.db608da20138f7fa58450a840e38358d.svg";
export { ForwardRef as ReactComponent };